import { Button, ButtonProps, InlineLoading } from '@carbon/react';
import { Download } from '@carbon/react/icons';
import { FC } from 'react';

interface Props extends ButtonProps<any> {
  loading: boolean;
  loadingText: string;
  hasIconOnly?: boolean;
  iconDescription?: string;
  kind?: 'ghost' | 'primary' | 'secondary' | 'tertiary';
}

const DownloadButton: FC<Props> = ({
  children,
  loadingText,
  loading,
  kind = 'ghost',
  size = 'md',
  hasIconOnly = false,
  iconDescription,
  ...rest
}: Props) => {
  return loading ? (
    <Button kind="ghost" size={size} disabled>
      <InlineLoading description={loadingText} />
    </Button>
  ) : (
    <Button
      hasIconOnly={hasIconOnly}
      iconDescription={iconDescription}
      kind={kind}
      size={size}
      renderIcon={Download}
      {...rest}
    >
      {children}
    </Button>
  );
};

export { DownloadButton };
